import { useMemo } from "react";
import { useFetch } from "../../../hooks/api";
import { useAppSelector } from "../../../redux/hooks";

interface ProfileSpec {
  name: string;
  marketplaces: string[];
  profile_id: number;
}

/** Amazon Advertising profiles the user can pick from during onboarding, fetched once the Advertising API is connected. */
export function useAdvertisingProfileOptions() {
  const advertisingConnected = useAppSelector((state) => state.amz_onboard.amazon_advertising_access === "connected");

  const { data, isLoading, isSuccess } = useFetch<{
    seller?: { [key: string]: ProfileSpec };
    vendor?: { [key: string]: ProfileSpec };
  }>(
    ["amazonProfiles"],
    `/api/accounts/`,
    {},
    {
      enabled: advertisingConnected,
      select: (res) => res.data,
    },
  );

  const formattedProfiles = useMemo(() => {
    return [
      ...Object.values(data?.seller ?? {}).map((profile) => ({
        label: profile.name,
        value: profile.name,
        type: "seller",
        marketPlaces: profile.marketplaces,
        profileId: profile.profile_id,
      })),
      ...Object.values(data?.vendor ?? {}).map((profile) => ({
        label: profile.name,
        value: profile.name,
        type: "vendor",
        marketPlaces: profile.marketplaces,
        profileId: profile.profile_id,
      })),
    ];
  }, [data]);

  const emptyProfileList = formattedProfiles.length === 0 && isSuccess && advertisingConnected;

  return { formattedProfiles, emptyProfileList, isLoading };
}
